import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import kebabCase from 'lodash/kebabCase.js';
import upperFirst from 'lodash/upperFirst.js';
import { componentGenerator } from '@wix/gena';
import { getEditorReactComponentExtensionPath } from '@wix/cli-astro-definitions';
import { isStandaloneExtensionsProject } from '@wix/cli-custom-extensions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const EDITOR_REACT_COMPONENT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/editor-react-component'
);

export async function generateEditorReactComponent(
  projectFolder: string,
  route: string,
  name: string,
  description: string,
  codeIdentifier?: string
) {
  const cwd = getEditorReactComponentExtensionPath(projectFolder, route);
  const camelCaseName = camelCase(route);
  const pascalCaseName = upperFirst(camelCaseName);

  const { relativePathToConfigFile } = getExtensionRelativePaths({
    cwd,
    projectFolder,
    extensionFileName: kebabCase(route),
    codeFileType: 'tsx',
  });

  const config = {
    id: randomUUID(),
    name,
    type: codeIdentifier
      ? `${codeIdentifier}.${pascalCaseName}`
      : pascalCaseName,
    pascalCaseName,
    camelCaseName,
    kebabCaseName: kebabCase(route),
    description: description.replaceAll('\\', '\\\\').replaceAll("'", "\\'"),
  };
  const isCustomExtensionsProject =
    await isStandaloneExtensionsProject(projectFolder);

  const genResult = await componentGenerator({
    template: EDITOR_REACT_COMPONENT_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      builderPackage: isCustomExtensionsProject
        ? '@wix/custom-extensions'
        : '@wix/astro/builders',
      config,
    },
  });

  await modifyExtensionsEntry({
    projectFolder,
    extensionName: camelCaseName,
    relativePath: relativePathToConfigFile,
    isCustomExtensionsProject,
  });

  return genResult;
}
